<template>
  <div 
    class="drag-zone transition-all duration-300 ease-in-out py-1"
    :class="{
      'is-drag-active': isDragging,
      'is-drag-over': isDragOver,
      'has-drop-target': hasDropTarget
    }"
    @dragover.prevent="handleDragOver"
    @dragleave="handleDragLeave"
    @drop.prevent="handleDrop"
  >
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    categories: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      isDragOver: false,
      isDragging: false,
      hasDropTarget: false
    };
  },
  methods: {
    handleDragOver() {
      this.isDragOver = true;
      this.hasDropTarget = !!e.target.closest('.category-item');
    },
    handleDragLeave(e) {
      if (!e.relatedTarget?.closest('.drag-zone')) {
        this.isDragOver = false;
      }
    },
    handleDrop(e) {
      this.isDragging = false;
      this.isDragOver = false;

      document.querySelectorAll('.category-item').forEach(item => {
        item.classList.remove('is-drag-over');
      });

      const data = JSON.parse(e.dataTransfer.getData('text/plain'));
      
      const dropTarget = e.target.closest('.category-item');
      const dropZone = this.$el;
      const items = [...dropZone.querySelectorAll('.category-item')];
      
      const dropIndex = dropTarget ? items.indexOf(dropTarget) : items.length;
      const newPosition = dropIndex + 1;
      
      this.$emit('reorder', {
        ...data,
        newPosition
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.drag-zone {
  &.is-drag-active {
    @apply bg-slate-50 dark:bg-slate-800/50 rounded-lg;
  }
}
</style>
